// Module
var code = "<h1 id=\"user\">User</h1> <p>New users can be invited to create a profile and sign on to the system here.</p> ";
// Exports
module.exports = code;